/**
 * Configuration for Monitoring & Error Reporting
 */
export const DEFAULT_CONFIG = {
  apiKey: 'd8ac2cc6eabece761b7a59fe6d0db9f9',
  enabledReleaseStages: ['production', 'staging', 'development', 'local'],
  appVersion: '1.0.0',
  endpoints: {
    notify: '/api/monitoring/notify',
    sessions: '/api/monitoring/sessions',
  },
};

/**
 * Detect the current environment/release stage based on hostname or meta tag.
 * Supports:
 * - Local: radicristiana.test:8888, localhost, 127.0.0.1 -> 'local'
 * - Staging: dev.radiocristiana.cl -> 'staging'
 * - Production: radiocristiana.cl, www.radiocristiana.cl -> 'production'
 *
 * @returns {string} The detected environment name
 */
export function detectEnvironment() {
  if (typeof window === 'undefined') {
    return 'production';
  }

  // 1. Check meta tag if rendered by backend (e.g. <meta name="app-env" content="production">)
  const metaEnv = document.querySelector('meta[name="app-env"]');
  if (metaEnv && metaEnv.getAttribute('content')) {
    const env = metaEnv.getAttribute('content').trim().toLowerCase();
    if (env) {
      return env;
    }
  }

  // 2. Check window.APP_ENV if defined
  if (window.APP_ENV && typeof window.APP_ENV === 'string') {
    return window.APP_ENV.trim().toLowerCase();
  }

  // 3. Detect via hostname and port
  const hostname = window.location.hostname || '';
  const host = window.location.host || '';

  if (
    hostname === 'dev.radiocristiana.cl' ||
    hostname.startsWith('dev.') ||
    hostname.startsWith('staging.')
  ) {
    return 'staging';
  }

  if (
    hostname === 'radiocristiana.cl' ||
    hostname === 'www.radiocristiana.cl' ||
    hostname.endsWith('radiocristiana.cl')
  ) {
    return 'production';
  }

  if (
    hostname === 'radiocristiana.test' ||
    host.includes('radiocristiana.test') ||
    hostname === 'radicristiana.test' ||
    host.includes('radicristiana.test') ||
    hostname.endsWith('.test') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    host.includes(':8888')
  ) {
    return 'local';
  }

  return 'production';
}

/**
 * Resolve Bugsnag API Key from meta tag, window variable or default.
 *
 * @returns {string}
 */
export function getApiKey() {
  if (typeof window !== 'undefined') {
    const metaApiKey = document.querySelector('meta[name="bugsnag-api-key"]');
    if (metaApiKey && metaApiKey.getAttribute('content')) {
      const key = metaApiKey.getAttribute('content').trim();
      if (key) {
        return key;
      }
    }
    if (window.BUGSNAG_FE_API_KEY && typeof window.BUGSNAG_FE_API_KEY === 'string') {
      return window.BUGSNAG_FE_API_KEY.trim();
    }
  }
  return DEFAULT_CONFIG.apiKey;
}

/**
 * Build consolidated configuration options
 *
 * @param {Object} customConfig
 * @returns {Object}
 */
export function getConfig(customConfig = {}) {
  const apiKey = customConfig.apiKey || getApiKey();
  const releaseStage = customConfig.releaseStage || detectEnvironment();
  return {
    ...DEFAULT_CONFIG,
    apiKey,
    releaseStage,
    ...customConfig,
  };
}



// WEBPACK FOOTER //
// ./resources/assets/js/monitoring/config.js